import {Routes} from '@angular/router';

/**
 * Root routing configuration. The empty path lazy-loads the CoreRoutes which
 * own the LandingComponent + ShellComponent + nested Pages tree.
 *
 * Wired into the application via `provideRouter(appRoutes)` in `app.config.ts`
 * (the legacy `RouterModule.forRoot(...)` NgModule has been removed).
 */
export const appRoutes: Routes = [
    {path: '', loadChildren: () => import('./core/core.routes').then((m) => m.coreRoutes)},
];
